export default ({ entities = [], entity } = {}) =>
  !entity
    ? entities
    : entities.find(({ id }) => entity.id === id)
    ? entities
    : [ entity ].concat(entities)
